"use strict";

var _defineProperty2 = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../utils");
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var IframeCell = /*#__PURE__*/function (_react$default$Compon) {
  function IframeCell() {
    var _this;
    _classCallCheck(this, IframeCell);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, IframeCell, [].concat(args));
    _defineProperty(_this, "state", {
      boxW: 0,
      boxH: 0
    });
    // Callback ref rather than componentDidMount: the container only exists in scaled mode, so
    // a cell switching unscaled -> scaled without remounting (editing the size in the admin and
    // seeing the preview update) would otherwise never get an observer and stay blank.
    _defineProperty(_this, "setContainer", function (el) {
      if (_this.resizeObserver) {
        _this.resizeObserver.disconnect();
        _this.resizeObserver = null;
      }
      _this.container = el;
      if (el && typeof ResizeObserver !== 'undefined') {
        _this.resizeObserver = new ResizeObserver(function () {
          return _this.updateBox();
        });
        _this.resizeObserver.observe(el);
      }
      _this.updateBox();
    });
    _defineProperty(_this, "updateBox", function () {
      var el = _this.container;
      if (!el) return;
      var boxW = el.clientWidth,
        boxH = el.clientHeight;
      if (boxW !== _this.state.boxW || boxH !== _this.state.boxH) _this.setState({
        boxW: boxW,
        boxH: boxH
      });
    });
    return _this;
  }
  _inherits(IframeCell, _react$default$Compon);
  return _createClass(IframeCell, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return (0, _utils.shouldCellComponentUpdate)(this.props, nextProps) || this.state !== nextState;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        defaultLanguage = _this$props.defaultLanguage,
        cell = _this$props.cell,
        intl = _this$props.intl,
        logEvent = _this$props.logEvent;
      var uri = (0, _utils.i18nData)(cell, 'uri', intl, defaultLanguage);
      if (!uri) return null;
      var iframe = function iframe(style) {
        return /*#__PURE__*/_react.default.createElement("iframe", {
          allowTransparency: "true",
          onClick: function onClick() {
            logEvent('iframeTouched', {
              cellId: cell.id
            });
          },
          style: style,
          src: uri,
          sandbox: "allow-scripts allow-same-origin allow-forms"
        });
      };

      // Admin set a fixed viewport (e.g. 390x844 to make the site serve its mobile layout):
      // render the iframe at that pixel size and CSS-scale it to fit the cell box.
      var vw = cell.viewport_width,
        vh = cell.viewport_height;
      if (vw && vh) {
        var scale = (0, _utils.fitScale)(this.state.boxW, this.state.boxH, vw, vh);
        return /*#__PURE__*/_react.default.createElement("div", {
          ref: this.setContainer,
          style: _objectSpread({
            position: 'relative',
            width: '100%',
            height: '100%',
            overflow: 'hidden'
          }, this.props.style)
        }, scale > 0 && iframe({
          position: 'absolute',
          top: 0,
          left: 0,
          border: 0,
          width: vw,
          height: vh,
          backgroundColor: 'transparent',
          transform: "scale(".concat(scale, ")"),
          transformOrigin: 'top left'
        }));
      }
      return iframe(_objectSpread({
        userSelect: 'none',
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundColor: "transparent"
      }, this.props.style));
    }
  }]);
}(_react.default.Component);
_defineProperty(IframeCell, "whyDidYouRender", true);
var _default = exports.default = (0, _reactIntl.injectIntl)(IframeCell);